import React from "react";
import { motion } from "framer-motion";
import {
  FADE_UP_INITIAL,
  FADE_UP_ANIMATE,
  VIEWPORT_ONCE,
  FADE_UP_TRANSITION,
} from "./animations";

// Lifestyle photo + ingredient benefits split — only renders when the brand
// declares a `lifestyle.image`. All text falls back through translations →
// English brand data (handled by parent BrandPage).
export default function BrandLifestyle({
  brand,
  lifestyleCaption,
  lifestyleTitle,
  lifestyleBody,
  lifestyleBenefits,
}) {
  return (
    <section className="relative" style={{ background: "#DFF0F7" }}>
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-24">
        <motion.div
          initial={FADE_UP_INITIAL}
          whileInView={FADE_UP_ANIMATE}
          viewport={VIEWPORT_ONCE}
          transition={FADE_UP_TRANSITION}
          className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center"
          data-testid={`brand-page-${brand.slug}-lifestyle`}
        >
          <div className="lg:col-span-5">
            <div className="rounded-3xl overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.15)] bg-white">
              <img
                src={brand.lifestyle.image}
                alt={lifestyleCaption || brand.name}
                className="w-full h-auto block"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            {lifestyleCaption && (
              <p className="overline text-[#001F39]/60 mb-4">
                {lifestyleCaption}
              </p>
            )}
            {lifestyleTitle && (
              <h2
                className="font-editorial italic text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-6"
                style={{ color: brand.palette.text }}
              >
                {lifestyleTitle}
              </h2>
            )}
            {lifestyleBody && (
              <p className="text-lg text-[#001F39]/80 leading-relaxed max-w-2xl">
                {lifestyleBody}
              </p>
            )}

            {lifestyleBenefits?.length > 0 && (
              <dl className="mt-8 grid sm:grid-cols-1 gap-6 max-w-2xl">
                {lifestyleBenefits.map((b) => (
                  <div
                    key={b.heading}
                    className="border-l-2 pl-5 py-1"
                    style={{ borderColor: brand.palette.accent }}
                  >
                    <dt
                      className="font-display font-bold text-lg mb-1"
                      style={{ color: brand.palette.text }}
                    >
                      {b.heading}
                    </dt>
                    <dd className="text-[15px] text-[#001F39]/75 leading-relaxed">
                      {b.text}
                    </dd>
                  </div>
                ))}
              </dl>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
